<!-- 慧日永明 -->
<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <img class="logo" src="../assets/home/ico_logo.png" />
          <span class="header_title">慧日永明</span>
          <span class="header_dec">慧日破诸暗，普明照世间，为践行中华文化自信而持续努力！</span>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <!-- 导航 -->
          <div class="navigation_container">
            <div class="item_contain" v-for="(item,index) in items" @click="onItemClick(index)">
              <img class="item_img" src="../assets/home/ico_flower.png" />
              <div class="iten_content_container">
                <div class="item_title_bg">
                  <span class="item_tittle">{{item.title}}</span>
                </div>
                <div class="item_dec_bg">
                  <span class="item_dec">{{item.dec}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="phone_container">
      <div class="phone_body_container">
        <!-- 头部 -->
        <div class="phone_header_container">
          <img class="phone_logo" src="../assets/home/phone_ico_logo.png" />
          <span class="phone_header_title">慧日永明</span>
          <span class="phone_header_dec">慧日破诸暗&nbsp;&nbsp;普明照世间<br />为践行中华文化自信而持续努力</span>
        </div>
        <!-- 内容 -->
        <div class="phone_content_container">
          <!-- 导航 -->
          <div class="phone_navigation_container">
            <div class="phone_item_contain" v-for="(item,index) in items" @click="onItemClick(index)">
              <img class="phone_item_img" src="../assets/home/phone_ico_flower.png" />
              <div class="phone_iten_content_container">
                <div class="phone_item_title_bg">
                  <span class="phone_item_tittle">{{item.title}}</span>
                </div>
                <div class="phone_item_dec_bg">
                  <span class="phone_item_dec">{{item.dec}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 分割线 -->
          <div class="phone_line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home',
    data() {
      return {
        items: [{
            title: '猫砍大画',
            dec: '用漫画描绘三千大千世界',
            index: 0
          },
          {
            title: '文创产品',
            dec: '把传统文化活学活用起来',
            index: 1
          },
          {
            title: '软件应用',
            dec: '各种实用工具',
            index: 2
          },
        ],
      };
    },
    methods: {
      onItemClick(index) {
        switch (index) {
          case 0:
            this.$router.replace({
              path: '/BigPicture'
            })
            break;
          case 1:
            this.$router.replace({
              path: '/CulturalProducts'
            })
            break;
          case 2:
            this.$router.replace({
              path: '/Application'
            })
            break;
        }
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logo {
    width: 8.333333vw;
    height: 8.333333vw;
    margin-top: 7.447916vw;
  }

  .header_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-top: 2.5vw;
  }

  .header_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 1.25vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .navigation_container {
    width: 100%;
    display: flex;
    margin-top: 1.666666vw;
    flex-direction: row;
    justify-content: center;
  }

  .item_contain {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 9.322916vw;
    /* transform:translate(-4.661458vw,0); */
  }

  .item_contain:nth-of-type(1) {
    margin-left: -0.330729vw;
  }

  .item_img {
    width: 3.072916vw;
    height: 2.760416vw;
  }

  .iten_content_container {
    display: flex;
    flex-direction: row;
    margin-top: 1.40625vw;
    align-items: flex-start;
  }

  .item_title_bg {
    background-size: 100%;
    width: 3.75vw;
    height: 16.614583vw;
    background-image: url('../assets/home/bg_title.png');
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
  }

  .item_tittle {
    font-family: ht;
    font-size: 1.666666vw;
    color: #000000;
    margin-top: 1.09375vw;
    writing-mode: vertical-lr;
  }

  .item_dec_bg {
    width: 3.75vw;
  }

  .item_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 2.34375vw;
    writing-mode: vertical-lr;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }

  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 87.466666vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_logo {
    width: 21.866666vw;
    height: 21.866666vw;
    margin-top: 31.466666vw;
  }

  .phone_header_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 6.4vw;
  }

  .phone_header_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
    text-align: center;
  }

  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  .phone_navigation_container {
    width: 100%;
    display: flex;
    margin-top: 4.266666vw;
    flex-direction: row;
    justify-content: center;
  }

  .phone_item_contain {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 7.466666vw;
    /* transform:translate(-4.661458vw,0); */
  }

  .phone_item_contain:nth-of-type(1) {
    margin-left: 8vw;
  }

  .phone_item_img {
    width: 8vw;
    height: 8.533333vw;
  }

  .phone_iten_content_container {
    display: flex;
    flex-direction: row;
    margin-top: 2.133333vw;
    align-items: flex-start;
  }

  .phone_item_title_bg {
    background-size: 100%;
    width: 10.133333vw;
    height: 40vw;
    background-image: url('../assets/home/phone_bg_title.png');
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
  }

  .phone_item_tittle {
    font-family: ht;
    font-size: 5.333333vw;
    color: #000000;
    margin-top: 4.266666vw;
    writing-mode: vertical-lr;
  }

  .phone_item_dec_bg {
    width: 10.133333vw;
  }

  .phone_item_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 4.266666vw;
    writing-mode: vertical-lr;
  }

  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue